exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.hamburger[data-v-4e9c855b] {\n\tdisplay: inline-block;\n\tcursor: pointer;\n\twidth: 15px;\n\theight: 15px;\n\ttransform: rotate(0deg);\n\ttransition: .38s;\n\ttransform-origin: 50% 50%;\n\tposition: relative;\n    top: -2px;\n}\n.hamburger.is-active[data-v-4e9c855b] {\n\ttransform: rotate(90deg);\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4e9c855b","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Hamburger/index.vue
// module id = 255
// module chunks = 88